import { render, staticRenderFns } from "./YourNeeds-Profile.vue?vue&type=template&id=96a28616&"
import script from "./YourNeeds-Profile.vue?vue&type=script&lang=js&"
export * from "./YourNeeds-Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports